angular.module('ihestiaCommonDirectives.labelActionHelper', [
]);